var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LibIcon } from './components';
var IMAdmin = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 66 : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, props = __rest(_a, ["title", "size", "isDisabled"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 1.18 * size, height: size, viewBox: "0 0 78 66", fill: "none" }, props),
        title && React.createElement("title", null, title),
        React.createElement("rect", { width: "12", height: "52.3448", rx: "2", transform: "matrix(0 -1 -1 0 68 23.574)", fill: isDisabled ? '#BEBEC0' : '#15DE93' }),
        React.createElement("circle", { cx: "6", cy: "17.9998", r: "6", fill: isDisabled ? '#BEBEC0' : '#15DE93' }),
        React.createElement("rect", { width: "12", height: "52", rx: "2", transform: "matrix(0 -1 -1 0 68 44.9998)", fill: isDisabled ? '#ECE9E9' : '#FFDE49' }),
        React.createElement("circle", { cx: "6", cy: "38.9998", r: "6", fill: isDisabled ? '#ECE9E9' : '#FFDE49' }),
        React.createElement("rect", { width: "12", height: "52.3448", rx: "2", transform: "matrix(0 -1 -1 0 68 65.9998)", fill: isDisabled ? '#DEDEE0' : '#FF5160' }),
        React.createElement("circle", { cx: "6", cy: "59.9998", r: "6", fill: isDisabled ? '#DEDEE0' : '#FF5160' }),
        React.createElement("path", { d: "M69.0003 0.666748C64.4003 0.666748 60.667 4.40008 60.667 9.00008C60.667 13.6001 64.4003 17.3334 69.0003 17.3334C73.6003 17.3334 77.3337 13.6001 77.3337 9.00008C77.3337 4.40008 73.6003 0.666748 69.0003 0.666748Z", fill: isDisabled ? '#9F9F9F' : '#1E70DD' }),
        React.createElement("path", { d: "M73.1673 9.8335H69.834V13.1668H68.1673V9.8335H64.834V8.16683H68.1673V4.8335H69.834V8.16683H73.1673V9.8335Z", fill: "white" })));
};
export var IMAdminIcon = function (_a) {
    var _b = _a.iconAriaHidden, iconAriaHidden = _b === void 0 ? true : _b, props = __rest(_a, ["iconAriaHidden"]);
    return (React.createElement(LibIcon, __assign({ icon: function () { return (React.createElement(IMAdmin, { isDisabled: props.isDisabled, size: props.size, title: props.title, "aria-hidden": iconAriaHidden })); } }, props)));
};
//# sourceMappingURL=IMAdminIcon.js.map